var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#27A376"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9999 13.6138C13.956 13.6138 13.1132 14.4566 13.1132 15.5005C13.1132 16.5443 13.956 17.3871 14.9999 17.3871C16.0438 17.3871 16.8866 16.5443 16.8866 15.5005C16.8866 14.4566 16.0438 13.6138 14.9999 13.6138ZM12.1132 15.5005C12.1132 13.9043 13.4038 12.6138 14.9999 12.6138C16.596 12.6138 17.8866 13.9043 17.8866 15.5005C17.8866 17.0966 16.596 18.3871 14.9999 18.3871C13.4038 18.3871 12.1132 17.0966 12.1132 15.5005Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50489 13.4984C10.0988 10.9929 12.4346 9.48047 14.9999 9.48047C17.5653 9.48047 19.9012 10.993 21.4951 13.4988C21.8584 14.0683 22.0232 14.7979 22.0232 15.4971C22.0232 16.1964 21.8584 16.9259 21.4951 17.4955C19.9012 20.0013 17.5653 21.5138 14.9999 21.5138C12.4345 21.5138 10.0986 20.0013 8.50468 17.4955C8.14137 16.9259 7.97656 16.1964 7.97656 15.4971C7.97656 14.7978 8.14143 14.0681 8.50489 13.4984ZM14.9999 10.4805C12.8587 10.4805 10.8078 11.7413 9.34844 14.0355L9.34802 14.0362C9.11163 14.4065 8.97656 14.9366 8.97656 15.4971C8.97656 16.0576 9.11163 16.5878 9.34802 16.9581L9.34844 16.9588C10.8078 19.253 12.8587 20.5138 14.9999 20.5138C17.1411 20.5138 19.192 19.253 20.6514 16.9588L20.6518 16.9581C20.8882 16.5878 21.0232 16.0576 21.0232 15.4971C21.0232 14.9366 20.8882 14.4065 20.6518 14.0362L20.6514 14.0355C19.192 11.7413 17.1411 10.4805 14.9999 10.4805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowTableIcon);
export default __webpack_public_path__ + "static/media/showTableIcon.86e683b5de460bd50ccdb9201a941d12.svg";
export { ForwardRef as ReactComponent };